import { defineStore } from 'pinia'

enum GdprStatus {
    Accepted,
    Refused,
    NotChosen
}

const useGdprStore = defineStore('gdpr', {
    state: () => ({
        status: GdprStatus.NotChosen
    }),
    actions: {
        accept (): void {
            this.status = GdprStatus.Accepted
        },
        askLater (): void {
            this.status = GdprStatus.NotChosen
        },
        reject (): void {
            this.status = GdprStatus.Refused
        }
    },
    getters: {
        accepted: (state): boolean => {
            return state.status === GdprStatus.Accepted
        },
        notChosen: (state): boolean => {
            return state.status === GdprStatus.NotChosen
        }
    },
    persist: true
})

export {
    GdprStatus,
    useGdprStore
}
